<template>
    <div>
        <label :for="name"><slot /></label>

        <div class="flex items-center">
            <button
            type="button"
            class="inline-flex items-center justify-center rounded-full w-8 h-8"
            :class="canDecrement && count > minCount ? 'bg-red shadow-lg-red' : 'bg-gray-500'"
            @click="decrement"
            >
                <img src="/assets/frontend/svg/icon_minus.svg" alt="">
            </button>

            <input
                class="w-16 text-center mx-4"
                type="text"
                :name="name"
                :min="minCount"
                :max="maxCount"
                v-model="count" />

            <button
                type="button"
                class="inline-flex items-center justify-center rounded-full w-8 h-8"
                :class="canIncrement && count < maxCount ? 'bg-green shadow-lg-green' : 'bg-gray-500'"
                @click="increment"
            >
                <img src="/assets/frontend/svg/icon_plus.svg" alt="">
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "counter-button",
    props: {
        initialCount: {
            type: Number,
            default: 2
        },
        name: {
            type: String,
            default: 'count'
        },
        minCount: {
            type: Number,
            default: 0
        },
        maxCount: {
            type: Number,
            required: true
        },
        canIncrement: {
            type: Boolean,
            default: true,
        },
        canDecrement: {
            type: Boolean,
            default: true,
        }
    },

    data: () => ({
        count: 0
    }),

    watch: {
        count() {
            this.$emit('change', this.count);
        }
    },

    mounted() {
        this.count = this.initialCount;
    },

    methods: {
        increment() {
            if (this.canIncrement && this.count < this.maxCount) {
                this.count++;
            }
        },

        decrement() {
            if (this.canDecrement && this.count > this.minCount) {
                this.count--;
            }
        }
    }
};
</script>
